var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9846 12.6996C10.2753 12.6996 9.56606 12.4624 8.96104 11.9817L0 4.87711V14.7996C0 15.959 0.922107 16.8996 2.05962 16.8996H19.9096C21.0471 16.8996 21.9692 15.9594 21.9692 14.7996V4.87711L13.0099 11.9865C12.4049 12.4634 11.6926 12.6996 10.9846 12.6996ZM0.698982 3.65648L9.8042 10.8796C10.4989 11.4309 11.4721 11.4309 12.1667 10.8796L21.272 3.65648C21.6732 3.30648 21.9692 2.76836 21.9692 2.19961C21.9692 1.0398 21.0467 0.0996094 19.9096 0.0996094H2.05962C0.922107 0.0996094 0 1.0398 0 2.19961C0 2.76836 0.257881 3.30648 0.698982 3.65648Z",
    fill: "#C71002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.69e3ff7eafc643b68442502d67ecacf2.svg";
export { ForwardRef as ReactComponent };